import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
// import Keycloak from 'keycloak-js';
import keycloak from '../keycloak';

export const useAuthStore: any = defineStore('authStore', () => {
  const kc = keycloak;

  const token = ref<string>('');

  const username = ref<string>('');
  const name = ref<string>('');
  const email = ref<string>('');

  const roles = ref<string[]>([]);

  const initialized = ref<boolean>(false);

  const isAuthenticated = computed(() => kc.authenticated);
  const isAuthorized = computed(() => kc.authenticated && kc.tokenParsed?.realm_access?.roles?.includes('access-wms'));
  const isWmsAdmin = computed(() => roles.value.includes('wms-admin'));

  async function initAuth() {
    if (initialized.value) return;

    try {
      const authenticated = await kc.init({
        // onLoad: 'check-sso', // oder 'login-required'
        onLoad: 'login-required', // oder 'check-sso'
        checkLoginIframe: false, // Optional, um die iframe-Überprüfung zu deaktivieren
        // silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        // enableLogging: true, // Optional, um Protokollierung zu aktivieren
        pkceMethod: 'S256', // Optional, um PKCE zu verwenden
      });

      // sobald init durch ist, Fragment aus der URL löschen
      if (window.location.hash.includes('code=')) {
        history.replaceState(history.state, document.title, window.location.pathname + window.location.search);
      }

      initialized.value = true;

      if (authenticated && kc.token) {
        token.value = kc.token;
        roles.value = kc.tokenParsed?.realm_access?.roles || [];

        username.value = kc.idTokenParsed?.preferred_username || '';
        name.value = kc.idTokenParsed?.name || '';
        email.value = kc.idTokenParsed?.email || '';
      }
    } catch (error) {
      console.error('Keycloak initialization failed:', error);
    }
  }

  function login() {
    sessionStorage.clear(); // Session-Storage leeren, um alte Daten zu entfernen
    kc.login({ redirectUri: window.location.origin });
  }

  function logout() {
    sessionStorage.clear(); // Session-Storage leeren, um alte Daten zu entfernen
    // Keycloak kümmert sich um Redirect und Session-Cleanup
    kc.logout({ redirectUri: window.location.origin });
  }

  async function updateToken(minValidity: number = 60) {
    const refreshed = await kc.updateToken(minValidity);
    if (refreshed && kc.token) {
      token.value = kc.token!;
    }

    return refreshed;
  }

  return {
    kc,
    token,
    username,
    name,
    email,
    roles,

    isAuthenticated,
    isAuthorized,
    isWmsAdmin,

    initAuth,
    login,
    logout,
    updateToken,
  };
});
